import React from 'react'
import styled from 'styled-components'
import FormErrorMessage from 'components/atoms/FormErrorMessage'
import { Input, Checkbox } from 'antd'
import Colors from 'styles/colors'

class LoginForm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { account, ui, onSubmit, onChange } = this.props
    return (
      <form onSubmit={onSubmit} acceptCharset="UTF-8">
        <h2 className="signup-box__title">{i18n.t('page.account.l_00017')}</h2>
        <div className="signup-box__md-top">
          <input name="utf8" type="hidden" value="✓" />
          <input
            type="hidden"
            name="authenticity_token"
            value={this.props.authenticity_token}
          />
          <EmailInput>
            <InputComponent
              id="email"
              onChange={onChange}
              className="w100pa"
              name="email"
              type="email"
              value={account.email}
              placeholder={i18n.t('page.shared.l_00046')}
            />
            {ui.errors && ui.errors['email'] && (
              <FormErrorMessage>{ui.errors['email']}</FormErrorMessage>
            )}
          </EmailInput>
          <PasswordInput>
            <InputComponent
              id="password"
              onChange={onChange}
              type="password"
              name="password"
              value={account.password}
              className="w100pa"
              placeholder={i18n.t('page.shared.l_00061')}
            />
            {ui.errors && ui.errors['password'] && (
              <FormErrorMessage>{ui.errors['password']}</FormErrorMessage>
            )}
          </PasswordInput>
        </div>
        <div className="signup-box__login-checkbox">
          <CheckboxComponent
            onClick={onChange}
            checked={account.rememberMe}
            name="rememberMe"
          >
            {i18n.t('page.account.l_00018')}
          </CheckboxComponent>
        </div>
        <p className="signup-box__login-btn">
          <input
            type="submit"
            name="commit"
            className="button-blue pt15 pb15 w100pa"
            value={i18n.t('page.shared.l_00015')}
          />
        </p>
      </form>
    )
  }
}

const InputComponent = styled(Input)`
  height: 40px;

  &.ant-input {
    border-radius: 6px;
    border-color: ${Colors.mono.gray40};
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    font-size: 14px;
    &::-webkit-input-placeholder {
      color: ${Colors.mono.gray40};
    }
    &:hover {
      border-color: ${Colors.brand.primary.main};
    }
    &.ant-input-disabled {
      &:hover {
        border-color: #e6d8d8;
      }
    }
    &:focus {
      border-color: ${Colors.brand.primary.main};
      box-shadow: none;
    }
  }
  &.ant-input-affix-wrapper {
    .ant-input {
      height: 40px;
      font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
        'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
        'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
        'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
      font-size: 14px;
      &::-webkit-input-placeholder {
        color: ${Colors.mono.gray40};
      }
      &:hover {
        border-color: ${Colors.brand.primary.main};
      }
      &.ant-input-disabled {
        &:hover {
          border-color: #e6d8d8;
        }
      }
      &:focus {
        border-color: ${Colors.brand.primary.main};
        box-shadow: none;
      }
    }
    :hover .ant-input:not(.ant-input-disabled) {
      border-color: ${Colors.brand.primary.main};
    }
  }
`

const EmailInput = styled.div`
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 20px;
`

const PasswordInput = styled.div`
  margin: 0 auto;
  padding-bottom: 10px;
`

const CheckboxComponent = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    display: inline-block;
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    .ant-checkbox-inner {
      top: 1px;
      width: 20px;
      height: 20px;
      :after {
        top: 50%;
        left: 50%;
        transform: rotate(45deg) scale(0) translate(-50%, -50%);
        transform-origin: top;
      }
      .ant-checkbox-input {
        &:focus {
          border-color: ${Colors.brand.primary.main};
        }
      }
    }
    .ant-checkbox {
      vertical-align: top;
    }
    .ant-checkbox-wrapper + span,
    .ant-checkbox + span {
      line-height: 1.35;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${Colors.brand.primary.main};
    }
    .ant-checkbox-checked {
      &.ant-checkbox-disabled .ant-checkbox-inner:after {
        border-color: ${Colors.mono.white};
      }
      &:after {
        border: none;
      }
      .ant-checkbox-inner {
        &:after {
          -webkit-transition: none;
          transition: none;
          transform: rotate(45deg) scale(1) translate(-50%, -50%);
        }
      }
    }
    &:hover {
      .ant-checkbox-inner,
      .ant-checkbox:hover .ant-checkbox-inner,
      .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: ${Colors.brand.primary.main};
      }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${Colors.mono.white};
      border-color: ${Colors.brand.primary.main};
    }
    .ant-checkbox-checked .ant-checkbox-inner:after {
      border-color: ${Colors.brand.primary.main};
    }
  }
`

export default LoginForm
